import { createGetApi } from "@api/util/createGetApi";

import type { IApiResponse } from "@api";
import type { IFinancialGetAllParams } from "@api/stores/financial/types";
import type { IFileResponse } from "@interfaces";

import type { IPathBaseParam } from "./path";

const getApis = createGetApi<
  IApiResponse<IFileResponse>,
  IPathBaseParam,
  IFinancialGetAllParams
>("stores.financial.exportExcel");

export const exportExcel = {
  ...getApis,
};
